// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useMutation } from "@tanstack/react-query";
import { authClient } from "@/lib/auth/auth-client";

// Password changes live on the auth service (:8001), so this hook goes through the auth client
// (authenticated via the stored token) rather than the back-office `@/api/client`.

export function useChangePasswordMutation() {
  return useMutation({
    mutationFn: ({ oldPassword, newPassword }: { oldPassword: string; newPassword: string }) =>
      authClient.changePassword(oldPassword, newPassword),
  });
}
